/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Airport } from '../../models/airport';
import { BaseResponse } from '../../models/base-response';

export interface CommonControllerDeleteAirport$Params {
  code: string;
}

export function commonControllerDeleteAirport(http: HttpClient, rootUrl: string, params: CommonControllerDeleteAirport$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Airport;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerDeleteAirport.PATH, 'delete');
  if (params) {
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: Airport;
      }>;
    })
  );
}

commonControllerDeleteAirport.PATH = '/common/airports/{code}';
